export function isDestructiveConfirmPhraseValid(typedPhrase: string, expectedPhrase: string): boolean {
  if (!expectedPhrase) {
    return false
  }
  return typedPhrase === expectedPhrase
}
